/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M45.537 0H2.463C.526 0-.492 2.298.822 3.743l17.465 18.943c.493.558.788 1.247.788 2.003v21.832c0 1.313 1.576 1.97 2.528 1.05l6.074-6.96c.821-.985 1.248-1.477 1.248-2.429V24.721c0-.755.295-1.444.788-2.002L47.178 3.776C48.492 2.298 47.474 0 45.537 0z"/>'
}
